import { render, staticRenderFns } from "./UploadFIleOrImageMultip.vue?vue&type=template&id=8c1d0dfa&scoped=true"
import script from "./UploadFIleOrImageMultip.vue?vue&type=script&lang=js"
export * from "./UploadFIleOrImageMultip.vue?vue&type=script&lang=js"
import style0 from "./UploadFIleOrImageMultip.vue?vue&type=style&index=0&id=8c1d0dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1d0dfa",
  null
  
)

export default component.exports